import React from "react"
import ColorTheme from "../pages/ColorTheme"
import PatternTheme from "../pages/PatternTheme"
import ShapesTheme from "../pages/ShapesTheme"
import GradientTheme from "../pages/GradientTheme"

function Color(props) {
    return <ColorTheme image = {props.image} />
}
function Pattern(props) {
    return <PatternTheme image = {props.image} />
}
function Gradient(props) {
    return <GradientTheme image = {props.image} />
}
function Shape(props) {
    return <ShapesTheme image = {props.image} />
}
export { Color, Pattern, Gradient, Shape } 